"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCurrency = void 0;
/** Used for convert english number to currency mode */
function toCurrency(value, formatCurrency) {
    if (!value)
        return "";
    value = value.replace(/[^\d.-]/g, "");
    var _a = value.split("."), integer = _a[0], decimal = _a[1];
    if (integer) {
        integer = integer
            .split("")
            .reverse()
            .reduce(function (acc, cur, index) {
            if (index % 3 === 0 && index !== 0) {
                acc.push(",");
            }
            acc.push(cur);
            return acc;
        }, [])
            .reverse()
            .join("")
            .replace(/^([-]{0,1}),/, "$1");
    }
    if (decimal && formatCurrency) {
        decimal = decimal.replace(/[^\d.-]/g, "").replace(/(\d{3})/g, "$1,");
    }
    return "".concat(integer).concat(value.includes(".") ? "." + decimal : "");
}
exports.toCurrency = toCurrency;
//# sourceMappingURL=currency.js.map